import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { DEFERRED_MESSAGE } from "@/lib/offlineTransport";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { verifyEmail } = useAuth();
  const started = useRef(false);
  const [status, setStatus] = useState("checking");
  const email = params.get("email") || "";
  const token = params.get("token") || "";

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    if (!email || !token) {
      setStatus("missing");
      return;
    }
    setStatus("checking");
    verifyEmail({ email, token })
      .then(() => {
        toast.success("E-mailadres bevestigd");
        setStatus("done");
        navigate("/", { replace: true });
      })
      .catch((error) => setStatus(error?.response?.data?.detail === DEFERRED_MESSAGE ? "offline" : "failed"));
  }, [email, navigate, token, verifyEmail]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <div className="w-full max-w-sm rounded-2xl bg-white border border-zinc-200 p-6 text-center">
        <div className="font-display text-2xl font-bold text-zinc-900">E-mail bevestigen</div>
        {status === "checking" && <div className="mt-2 text-sm text-zinc-500">We controleren je bevestigingslink...</div>}
        {status === "missing" && <div className="mt-2 text-sm text-zinc-500">Deze bevestigingslink mist gegevens.</div>}
        {status === "failed" && <div className="mt-2 text-sm text-red-600">Deze link is ongeldig of verlopen.</div>}
        {status === "offline" && <div className="mt-2 text-sm text-amber-700">{DEFERRED_MESSAGE}</div>}
        {status !== "checking" && status !== "done" && (
          <Button asChild className="mt-5 w-full h-11 bg-amber-600 hover:bg-amber-700">
            <Link to="/login">Naar inloggen</Link>
          </Button>
        )}
      </div>
    </div>
  );
}
